export default "__VITE_ASSET__CKqHBMKW__"